import { render, staticRenderFns } from "./ExpensesNew.vue?vue&type=template&id=8152d44a&scoped=true"
import script from "./ExpensesNew.vue?vue&type=script&lang=js"
export * from "./ExpensesNew.vue?vue&type=script&lang=js"
import style0 from "./ExpensesNew.vue?vue&type=style&index=0&id=8152d44a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8152d44a",
  null
  
)

export default component.exports